import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import databaseReducer from './slices/databaseSlice';
import authReducer from './slices/authSlice';
import expenseReducer from './slices/expenseSlice';
import categoryReducer from './slices/categorySlice';
import dashboardReducer from './slices/dashboardSlice';
import challengeReducer from './slices/challengeSlice';
import settingsReducer from './slices/settingsSlice';
import spendingAnalyticsReducer from './slices/spendingAnalyticsSlice';
import achievementReducer from './slices/achievementSlice';
import pointsReducer from './slices/pointsSlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    database: databaseReducer,
    auth: authReducer,
    expenses: expenseReducer,
    categories: categoryReducer,
    dashboard: dashboardReducer,
    challenges: challengeReducer,
    settings: settingsReducer,
    spendingAnalytics: spendingAnalyticsReducer,
    achievements: achievementReducer,
    points: pointsReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
